<script setup lang="ts">
import StatusTag from "~/components/Common/StatusTag.vue";
import { useLearningPathTrainingsAttendees } from "~/composables/learning-path/useLearningPathTrainingsAttendees";

defineProps({
  row: { type: Object },
});

const { headers, statusMapping } = useLearningPathTrainingsAttendees();
</script>
<template #row="{ row }">
  <td v-if="headers[0]?.visible">
    <div class="index_row">
      <div>{{ row?.displayValue ? row?.displayValue : "-" }}</div>
    </div>
  </td>
  <td v-if="headers[1]?.visible">
    <div class="index_row">
      <StatusTag v-if="row?.status && row?.status !== 'not_booked'" :tag="statusMapping(row?.status)"></StatusTag>
      <span v-else class="text-medium-grey-color">Non inscrit</span>
    </div>
  </td>
  <td v-if="headers[2]?.visible">
    <div class="index_row">
      <span>{{ row?.comment ? row?.comment : "-" }}</span>
    </div>
  </td>
</template>
<style scoped lang="scss"></style>
